import React from "react";
import { Dropdown } from "semantic-ui-react";
import { languageList } from "../../../../messages";
import { useDispatch } from "react-redux";
import { setLocale } from "../../../../actions/localeReducer";

type Props = {
  lang: string;
};

const LanguageSelector: React.FunctionComponent<Props> = ({ lang }) => {
  const dispatch = useDispatch();
  function getFlag(lang: string): any {
    return lang === "en" ? "gb" : lang;
  }
  const mainFlag = getFlag(lang);
  return (
    <nav>
      <Dropdown
        text={lang.toUpperCase()}
        flag={mainFlag}
        floating
        labeled
        button
        className={"flag"}
      >
        <Dropdown.Menu>
          {languageList.map((l: string) => {
            const flag = getFlag(l);
            return (
              lang !== l && (
                <Dropdown.Item
                  flag={flag}
                  text={l.toUpperCase()}
                  onClick={() => dispatch(setLocale(l))}
                  key={`FLAG_${l}`}
                />
              )
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    </nav>
  );
};

export default LanguageSelector;
